import { React, useState, useEffect, useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import AutosuggestComponent from './AutosuggestComponent';

import { encoded } from '../../../utils/cryptoUtils';

import { GetAutoSuggestions } from '../../../redux/actions/Admin'; // Redux action

const VehicleAutosuggest = ({
    style,
    input_style,
    label,
    type,
    placeholder,
    name,
    value,
    onChange,
    required,
    hidden,
    disabled,
    display,
    setFormData
}) => {
    const dispatch = useDispatch();
    const autoSuggestionList = useSelector((state) => state.admin.autoSuggestionList || []);
    const [suggestions1, setSuggestions1] = useState([]);

    const escapeRegexCharacters = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

    const getSuggestions1 = (value) => {
        if (!value || typeof value !== "string") {
            return [];
        }

        setFormData((prev) => ({
            ...prev,
            vehicle: {}, // Clears vehicle when input is empty
        }));

        setFormData((prev) => ({
            ...prev,
            vehicle: {
                ...prev.vehicle,
                vehicle_nick_name: value,
            },
        }));
        return autoSuggestionList.filter((user) => {
            const vehicleObject = user.customObject || {}; // Ensure object exists

            const itemData = `${vehicleObject.registration_no?.toUpperCase() || ""} 
                              ${vehicleObject.vehicle_nick_name?.toUpperCase() || ""} 
                              ${vehicleObject.engine_no?.toUpperCase() || ""} 
                              ${vehicleObject.chassis_no?.toUpperCase() || ""}`.trim();

            const textData = escapeRegexCharacters(value.trim().toUpperCase());

            return itemData.includes(textData);
        });
    };

    const getSuggestionValue1 = (suggestion) => suggestion?.customObject?.vehicle_nick_name || "";

    const onChange1 = (event, { newValue }) => {
        setFormData((prev) => ({
            ...prev,
            vehicle: {
                ...prev.vehicle,
                vehicle_nick_name: newValue,
            },
        }));
    };

    const onSuggestionsFetchRequested1 = ({ value, reason }) => {
        if (!value || typeof value !== "string") return;
        if (reason === "input-changed") {
            let newData = getSuggestions1(value);
            if (newData?.length === 0 && value.length > 1) {
                dispatch(GetAutoSuggestions(
                    encoded(
                        JSON.stringify({
                            branch_id: localStorage.getItem("branch_id_1"),
                            object_type: "Vehicle",
                            type_of_entity: "CS",
                            search_value: value,
                        })
                    )
                )); // Redux call
            }
            setSuggestions1(newData);
        }
    };

    useEffect(() => {
            if (autoSuggestionList.length !== suggestions1.length) {
                setSuggestions1(autoSuggestionList);
            }
        }, [autoSuggestionList]);
    

    const onSuggestionsClearRequested1 = () => {
        setSuggestions1([]);
    };

    const onSuggestionSelected1 = (event, { suggestion }) => {
        event.preventDefault();

        if (!suggestion || !suggestion.customObject) {
            return;
        }

        const selectedVehicle = suggestion.customObject;
        console.log("Selected Vehicle:", selectedVehicle);

        setFormData((prev) => ({
            ...prev,
            brand_id_1: selectedVehicle?.brand_id,
            model_id_1: selectedVehicle?.model_id,
            vehicle: {
                ...selectedVehicle,
                insurance_date: selectedVehicle?.insurance_date ? moment(selectedVehicle?.insurance_date, "DD-MM-YYYY").toDate() : null,
                puc_date: selectedVehicle?.puc_date ? moment(selectedVehicle?.puc_date, "DD-MM-YYYY").toDate() : null,
            },
        }));
    };

    const onBlur1 = (event, { highlightedSuggestion }) => {
        if (!highlightedSuggestion || !highlightedSuggestion.customObject) {
            return;
        }

        const selectedVehicle = highlightedSuggestion.customObject;
        console.log("Highlighted Vehicle:", selectedVehicle);

        setFormData((prev) => ({
            ...prev,
            brand_id_1: selectedVehicle?.brand_id,
            model_id_1: selectedVehicle?.model_id,
            vehicle: {
                ...selectedVehicle,
                insurance_date: selectedVehicle?.insurance_date ? moment(selectedVehicle?.insurance_date, "DD-MM-YYYY").toDate() : null,
                puc_date: selectedVehicle?.puc_date ? moment(selectedVehicle?.puc_date, "DD-MM-YYYY").toDate() : null,
            },
        }));
    };


    return (
        <AutosuggestComponent
            style={style}
            input_style={input_style}
            label={label}
            type={type}
            placeholder="Vehicle..."
            required={required}
            name={name}
            value={value}
            hidden={hidden}
            disabled={disabled}
            display={display}
            suggestions={suggestions1}
            onSuggestionsFetchRequested={onSuggestionsFetchRequested1}
            onSuggestionSelected={onSuggestionSelected1}
            onSuggestionsClearRequested={onSuggestionsClearRequested1}
            getSuggestionValue={getSuggestionValue1}
            onChange={onChange1}
            onBlur={onBlur1}
        />
    );
};

VehicleAutosuggest.propTypes = {
    style: PropTypes.string,
    input_style: PropTypes.string,
    label: PropTypes.string,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    name: PropTypes.string.isRequired,
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    required: PropTypes.bool,
    hidden: PropTypes.bool,
    disabled: PropTypes.bool,
    display: PropTypes.bool,
    setFormData: PropTypes.func,
}

export default VehicleAutosuggest;
